module.exports = __webpack_public_path__ + "static/media/micActive.1f3ffb96.svg";